import { defineStore } from "pinia";
import { ref } from "vue";
import { client } from "@/main";
export const useMqttStore = defineStore("mqtt", () => {
    const deviceList = ref([]);
    const totalCount = ref(0);
    async function getList(queryData) {
        let sort = undefined;
        if (queryData.sortType === "asc") {
            sort = "+" + queryData.sort;
        }
        else if (queryData.sortType === "desc") {
            sort = "-" + queryData.sort;
        }
        const filters = {};
        for (const filter of queryData.filters ?? []) {
            filters[`${filter.field}[${filter.operator ?? "eq"}]`] = filter.value;
        }
        let search = undefined;
        if (queryData.search) {
            search = `${queryData.search}*`;
        }
        try {
            const { data } = await client.path("/mqtt/devices").method("get").create()({
                ...filters,
                sort,
                search,
                offset: queryData.currentPage * queryData.rowsPerPage,
                limit: queryData.rowsPerPage
            });
            deviceList.value = data.data ?? [];
            totalCount.value = data.metadata?.count ?? 0;
            return true;
        }
        catch (error) {
            console.error("Chyba při načítání MQTT zařízení:", error);
            return false;
        }
    }
    async function moveDevices({ deviceIds, dest_deviceGroup, dest_custServiceId, dest_projectId }) {
        const { data } = await client.path("/mqtt/devices/migration").method("post").create()(deviceIds.map((deviceId) => ({
            deviceId,
            dest_deviceGroup,
            dest_custServiceId,
            dest_projectId
        })));
        return data;
    }
    async function deleteDevice(device) {
        if (!device.deviceId) {
            return;
        }
        for (const dg of device.deviceGroups ?? []) {
            if (!dg.deviceGroupId) {
                continue;
            }
            await client.path("/device-groups/{id}/devices/{protocol}/{deviceId}/assign").method("delete").create()({
                id: dg.deviceGroupId.toString(),
                protocol: "mqtt",
                deviceId: device.deviceId
            });
        }
        return await client.path("/mqtt/devices/{id}").method("delete").create()({
            id: device.deviceId
        });
    }
    return {
        deviceList,
        totalCount,
        getList,
        moveDevices,
        deleteDevice
    };
});
